import TagList from '../Tags/TagList';
import noImage from '../../../../assets/images/no_image.png';

function ProjectItem({ eachPrj, index, getMediaList }) {

  const openGallary = () => {
    if(eachPrj.media.length > 0) {
      getMediaList(eachPrj.media)
    }
  }

  let thumbnailView;
  if(eachPrj.thumbnail) {
    thumbnailView = <img src={eachPrj.thumbnail} className="project-image" alt="project preview" />
  }else {
    thumbnailView = <img src={ noImage }  className="no-project-image" alt="project preview" />
  }

  return (
    <li className="item-list" key={index} onClick={ openGallary }>
      <div className="item-content">
        <div className="item-title white-text" onClick={ openGallary }>
          {eachPrj.title}
          <span className="download-icon">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              aria-hidden="true">
              <path d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" />
            </svg>
          </span>
        </div>
        <div className="item-body">
          <p>
            { eachPrj.body }
          </p>
        </div>

        <TagList tagList={ eachPrj.tags } />
      </div>

      <div className="item-image" onClick={openGallary}>
        {thumbnailView}
      </div>
    </li>
  );
}

export default ProjectItem;